<template>
  <div>
    <div class="card modal-card">
      <div class="pd-0">
        <header class="bandeau-modal card-header">
        </header>
        <div class="center">
          <div class="columns is-gapless">
            <div class="column mgt-20px">
              <h1 class="title is-size-3">{{ $t('listeIntervention.fusion.title')}}</h1>
            </div>
          </div>
        </div>
        <div class="card-content">
            <error-msg-component :messages="messages"
                                 :messagesChampsVide="messagesChampsVide"
                                 :champsVide="champsVide"
                                 :error="error"
                                 :title="'general.problemOccurred'"
                                 :withEmplyFields="true"
                                 @close="error = $event"/>
          <qd-message :title="$t('editionRemise.informations')"
                     type="is-info" v-if="demandesIntervention.length <= 1">
            {{ $t('listeIntervention.fusion.info.cantFusion') }}
          </qd-message>
          <div class="columns">
            <div class="column is-3">
              <b-field :label="$t('listeIntervention.fusion.etatFusion')">
                <div class="columns">
                  <b-dropdown v-model="newStateDemande" aria-role="list"
                              class="column is-12 disablejustifyCenter
                            margin-dropdown-content-left-10px dropdownSelect
                            setWidth100PercentOfSpan pdb-0
                            dropdown-multiple-background-hover-disabled">
                    <template #trigger>
                      <qd-button class="border-radius-4px" expanded>
                        <slot>
                          <div class="columns is-vcentered">
                            <span class="column is-1">
                              <b-icon :icon="getEtatInformation(newStateDemande).icon"
                                      :type="getEtatInformation(newStateDemande).type"
                                      class="mgt-5px"></b-icon>
                            </span>
                            <span class="column is-9 has-text-left">
                              {{ $t(getEtatInformation(newStateDemande).libelle) }}
                            </span>
                            <span class="column is-2 has-text-right">
                              <b-icon icon="chevron-down"></b-icon>
                            </span>
                          </div>
                        </slot>
                      </qd-button>
                    </template>
                    <b-dropdown-item aria-role="listitem"
                                     v-for="etatType in etatsIntervention"
                                     :key="etatType.key" :value="etatType.key">
                      <div class="media">
                        <b-icon class="media-left" :icon="etatType.icon"
                                :type="etatType.type"></b-icon>
                        <div class="media-content">
                          <h3>{{ $t(etatType.libelle) }}</h3>
                        </div>
                      </div>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-field>
            </div>
          </div>
          <div>

          </div>
          <div class="max-height-320 overflow-x-scroll">
          <v-client-table :data=demandesIntervention :columns="columns" :options="options"
                          ref="tableFusionDemandeIntervention"
                          class="mgt-20px">
            <div slot="selected" slot-scope="props" class="has-text-centered">
              <qd-radio @input="editSelectedFusion(props.row.id)"
                       name="name"
                       :value="props.row.selectedFusion"
                       native-value="Flint">
              </qd-radio>
            </div>
            <div slot="creationTime" slot-scope="props">
              {{ getDate(props.row.creationTime) }}
            </div>
            <div slot="demandeur" slot-scope="props">
              {{ getUser(props.row.demandeurId) }}
            </div>
            <div slot="etat" slot-scope="props">
              {{ $t(getEtat(props.row.etat)) }}
            </div>
            <div slot="agence" slot-scope="props">
              {{ getAgenceLibelle(props.row.agenceId) }}
            </div>
            <div slot="type" slot-scope="props">
              {{ $t(getTypeIntervention(props.row.type)) }}
            </div>
          </v-client-table>
          </div>
          <footer class="mgt-20px">
            <b-field>
              <div class="is-pulled-left boutonAction">
                <a class="button" @click="$parent.close()">
                  {{ $t('general.button.cancel') }}
                </a>
              </div>
              <div class="is-pulled-left boutonAction" @click="makeFusion">
                <button class="button is-addOrEdit" :disabled="demandesIntervention.length <= 1">
                  {{ $t('general.button.fusion') }}
                </button>
              </div>
            </b-field>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import formatDate from '@/services/general/formatDate';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import {
  ETAT_DEMANDE_INTERVENTION,
  ETAT_NOUVEAU,
  TYPE_INTERVENTION,
} from '@/configuration/logistique/intervention/interventionConf';
import cloneDeep from 'lodash/cloneDeep';
import { fusionAsync } from '@/api/logistique/demandeLogistique';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/intervention/translateIntervention';
import validation from '@/services/logistique/intervention/validationInterventionFusion';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_interventionFusion',
  props: {
    demandesIntervention: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      etatsIntervention: ETAT_DEMANDE_INTERVENTION,
      newStateDemande: ETAT_NOUVEAU,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      typeIntervention: TYPE_INTERVENTION,
    };
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    selectAll() {
      const select = !this.allInterventionSelected;
      this.demandesIntervention.forEach(item => {
        item.selectedFusion = select;
      });
    },
    editSelectedFusion(demandeId) {
      this.demandesIntervention.forEach((demande) => {
        demande.selectedFusion = false;
      });
      const demandeFind = this.demandesIntervention.find((demande) => {
        return demande.id === demandeId;
      });
      if (demandeFind) {
        demandeFind.selectedFusion = true;
      }
    },
    async makeFusion() {
      if (this.demandesIntervention.length <= 1) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const demandePere = this.demandesIntervention.find((demande) => {
          return demande.selectedFusion;
        });
        const fusionInformation = {
          demandesIdsAFusionner: this.demandesIntervention.map((demande) => demande.id),
          demandePereId: demandePere ? demandePere.id : null,
          etatFusion: this.newStateDemande,
        };
        await fusionAsync(fusionInformation);
        loadingComponent.close();
        this.$parent.close();
        this.$emit('recherche');
      } catch (e) {
        if (e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validation(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getDate(date) {
      return formatDate(date);
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agence) return agence.libelleAgence;
      return null;
    },
    getUser(userId) {
      const userFind = this.parametre(PARAMETRES_KEYS.utilisateur).find((user) => {
        return user.id === userId;
      });
      return userFind ? userFind.decorator.nomPrenom : '';
    },
    getEtat(etatDemande) {
      const etatFind = this.etatsIntervention.find((etat) => {
        return etat.key === etatDemande;
      });
      if (!etatFind) return null;
      return etatFind.libelle;
    },
    getEtatInformation(key) {
      return this.etatsIntervention.find((etat) => {
        return etat.key === key;
      });
    },
    getTypeIntervention(typeKey) {
      const type = this.typeIntervention.find((type) => {
        return type.key === typeKey;
      });
      if (!type) return null;
      return type.libelle;
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
    }),
    getAllInterventionSelected() {
      return this.demandesIntervention.filter((el) => {
        return el.selectedFusion;
      });
    },
    allInterventionSelected() {
      return this.getAllInterventionSelected.length === this.demandesIntervention.length
        && this.demandesIntervention.length > 0;
    },
    columns() {
      return ['selected', 'code', 'creationTime', 'actionLogistique', 'agence', 'demandeur', 'type', 'etat', 'otLie'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          etat: this.$t('listeIntervention.fusion.tab.etat'),
          code: this.$t('listeIntervention.fusion.tab.nDemande'),
          creationTime: this.$t('listeIntervention.fusion.tab.date'),
          actionLogistique: this.$t('listeIntervention.fusion.tab.sujetDemande'),
          demandeur: this.$t('listeIntervention.fusion.tab.demandeur'),
          otLie: this.$t('listeIntervention.fusion.tab.otLie'),
          agence: this.$t('listeIntervention.fusion.tab.agence'),
          type: this.$t('listeIntervention.fusion.tab.type'),
          selected: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        texts: texts,
        columnsClasses: {
          selected: 'colonneSelected',
        },
        sortable: ['code', 'creationTime', 'actionLogistique', 'type', 'etat'],
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
